import {useCallback, useEffect} from "react";

export const useScrollToSection = () => {
    const scrollToSection = useCallback(
        (id) => {
            if (location.pathname === "/") {
                const section = document.getElementById(id);
                if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                    window.history.replaceState(null, null, `#${id}`);
                }
            }
        },
        [location.pathname]
    );

    useEffect(() => {
        if (window.location.hash && location.pathname === "/") {
            const id = window.location.hash.substring(1);
            setTimeout(() => {
                scrollToSection(id);
            }, 500);
        }
    }, [location.pathname, scrollToSection]);

    return scrollToSection
}
